<template>
  <div class="direct-bind-wrapper">
    <div class="bind-type-wrapper">
      <!--<article class="weui-article">-->
      <!--&lt;!&ndash;<section>&ndash;&gt;-->
      <!--<p>请输入该停车券要绑定的车牌，车辆出入时，系统会自动找到该停车券。</p>-->
      <!--&lt;!&ndash;</section>&ndash;&gt;-->
      <!--</article>-->
      <article class="weui-article">
        <!--<section>-->
        <p style="font-size: 16px; font-weight: 500">
          停车时长: {{ parkHours || "暂无" }}
        </p>
        <p style="font-size: 16px; font-weight: 500">进场时间: {{ inTime || "暂无" }}</p>
        <!--</section>-->
      </article>
      <div ref="plateForm" class="weui-form-area">
        <div class="weui-cells weui-cells_form">
          <plate-input @onChange="getPlateNumber"></plate-input>
        </div>
        <div class="weui-btn-area">
          <button class="weui-btn"  :class="isClicked ? 'weui-btn_disabled' : 'weui-btn_primary'" :disabled="isClicked" @click="handleConfirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkNumberIsIn } from "../../../api/coupon/userNoFollowToGetCoupon";
import { userGetpaymentCoupon, userGetCoupon } from "../../../api/coupon/userGetCoupon";
import { userGetAuthCoupon } from "../../../api/coupon/userGetAuthCoupon";
import plateInput from "../components/plateInput";
import { pay } from "../../../api/coupon/pay";
import { mapGetters } from "vuex";
export default {
  name: "paymentAdvance",
  data() {
    return {
      isClicked: false,
      validateTime: null,
      prepay: false,
      time: null,
      inTime: undefined,
      parkHours: undefined,
      id: undefined,
      platenumber: undefined,
      urlSplit: undefined,
      parkinglotId: undefined,
    };
  },
  components: {
    plateInput,
  },
  computed: {
    ...mapGetters(["userOpenid"]),
  },
  created() {
    console.log(this.$route.query, "2345654");
    // this.prepay = Boolean(this.$route.query.prepay);
    this.prepay = this.$route.query.prepay === 'true' ? true : false;
    console.log(this.prepay,'this.prepay');
    this.id = this.$route.query.taskId;
    this.parkinglotId = this.$route.query.parkinglotId;
    this.validateTime = this.$route.query.validateTime;
    this.time = this.$route.query.time;
    // this.key = this.$route.query.key;
    this.key = decodeURIComponent(this.$route.query.key);

    let url = window.location.href;
    let urlList = url.split("key");
    this.urlSplit = urlList[0];
    this.urlSplit = this.urlSplit.slice(0, this.urlSplit.length - 1);
    this.AuthCoupon();

    // if (this.GetQueryString("isUserBindPlate")){
    //     this.id = this.$encryptUtil.decrypt(this.GetQueryString("taskId"));
    //     this.parkinglotId = this.$encryptUtil.decrypt(this.GetQueryString("parkinglotId"));
    // }
  },
  methods: {
    AuthCoupon() {
      
        let params = {
          pageAddress: this.urlSplit,
          signature: this.key,
        };
        userGetAuthCoupon(params).then((res) => {
          if ((res.code = !200)) {
            this.$router.push({ name: "paymentAdvanceerror" });
          }
        });
     
    },
    getPlateNumber(data) {
      console.log("传值", data);
      this.platenumber = data;
    },
    /*获取地址栏参数**/
    GetQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /*验证输入框非空**/
    handleConfirm() {
      if (!this.platenumber || this.platenumber.length < 7) {
        this.$weui.alert("车牌号长度有误！");
      } else {
        checkNumberIsIn({
          parkinglotId: this.parkinglotId,
          platenumber: this.platenumber,
        })
          .then((res) => {
            if (res.code === 200) {
           
              this.inTime = res.data.inTime;
              this.parkHours = res.data.parkHours;
              console.log(this.prepay,'prepay');
              if ( this.prepay) {
                console.log("1111111111");
                let form = {
                  bindMethod: 8,
                  openid: localStorage.getItem("userOpenId") || this.userOpenid,
                  platenumber: this.platenumber,
                  couponTaskId: this.id,
                  validateTime: this.validateTime * 60,
                  recId: res.data.id,
                  parkinglotId: this.parkinglotId,
                };
                this.userGetCoupon(form);
              } else {
                console.log("2222222222");
                let form = {
                  bindMethod: 8,
                  platenumber: this.platenumber,
                  couponTaskId: this.id,
                };
                userGetCoupon(form)
                  .then((res) => {
                    if (res.code === 200) {
                      this.isClicked = true
                      this.$weui.alert("领券成功", { title: "提示" });
                    } else {
                      throw new Error();
                    }
                  })
                  .catch(() => {
                    this.isClicked = false;
                  });
              }
            } else {
              throw new Error();
            }
          })
          .catch(() => {
            this.isClicked = false;
            this.$weui.alert("错误，请重试！");
          });
      }
    },
    /*用户领券**/
    userGetCoupon(form) {
      let params = {
        pageAddress: this.urlSplit,
        signature: this.key,
      };
      userGetAuthCoupon(params).then((res) => {
        if (res.code == 200) {
          userGetpaymentCoupon(form).then((res) => {
            if (res.code === 200) {
              this.isClicked = true;
              this.$weui.alert("领券成功", { title: "提示" });
            } else {
              this.isClicked = false;
              throw new Error();
            }
          });
        } else {
          this.isClicked = false;
          this.$weui.alert(res.msg, { title: "提示" });
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~common/stylus/variable';
.bind-type-wrapper{
	padding-top 20px
	.type-title{
		color #F43430
		font-size $article-p
		text-align center
		display flex
		div{
			width 10px
			height 10px
			line-height 10px
			text-align center
			font-weight 500
			padding 3px
			border-radius 50%
			border 1px solid #F43430
			margin auto
		}
	}
	.weui-article{
		padding-top 0
		padding-bottom 0
		p{
			color $article-merchant-p
			font-size $article-merchant-p
			line-height 20px
		}
	}
	.weui-cells{
		.weui-cell{
			padding 15px
		}
	}
	.weui-btn-area{
		margin-top 20px
		.weui-btn{
			width: 100%;
		}
		p{
			font-size $article-p
			color $article-merchant-p
			line-height 20px
			padding-top 10px
		}
	}
}
</style>
